<template>
  <section class="qrs-typography">
    <pageHeader>
      <h2 class="qrs-header-xl mt--0 mb--0">My wellbeing diary</h2>
    </pageHeader>
    <div v-if="loading">
      <div class="loader"></div>
      <p class="loading__text">Loading...</p>
    </div>

    <div v-else class="message-success__panel">
      <div class="message-success__panel__content">
        <!-- <img alt="Check circle icon" src="../../assets/img/check_circle.png" /> -->
        <h3><strong>No questions have been answered.</strong></h3>
        <p>Answer questions to populate your wellbeing diary with new entries.</p>

        <button
          name="continue"
          aria-label="continue"
          class="govuk-button"
          title="Continue to introduction"
          @click="returnToIntro()"
        >
          Continue <span class="screen-reader-text">to introduction</span>
        </button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "noEntriesAdded",
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    returnToIntro() {
      this.loading = !false;
      setTimeout(() => {
        this.loading = !true;
        this.$parent.goTo(this.$Intro);
      }, 1000);
    },
  },
};
</script>